import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const ArrowBackLine = ({ width = 20, height = 20, fill = '#4C5053', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.14417 10.625L10.4519 14.9327C10.5758 15.0566 10.6369 15.2016 10.6354 15.3677C10.6338 15.5338 10.5683 15.6815 10.4392 15.8108C10.3099 15.9315 10.1635 15.994 10 15.9983C9.83653 16.0026 9.69014 15.9401 9.56083 15.8108L4.27729 10.5273C4.19924 10.4492 4.14424 10.3669 4.11229 10.2804C4.08021 10.1939 4.06417 10.1004 4.06417 10C4.06417 9.89958 4.08021 9.80611 4.11229 9.71958C4.14424 9.63306 4.19924 9.55076 4.27729 9.47271L9.56083 4.18917C9.67625 4.07375 9.81917 4.01472 9.98958 4.01208C10.16 4.00944 10.3099 4.06847 10.4392 4.18917C10.5683 4.31847 10.6329 4.46695 10.6329 4.63458C10.6329 4.80236 10.5683 4.9509 10.4392 5.08021L6.14417 9.375H15.625C15.8024 9.375 15.9508 9.43486 16.0704 9.55458C16.1901 9.67417 16.25 9.82264 16.25 10C16.25 10.1774 16.1901 10.3258 16.0704 10.4454C15.9508 10.5651 15.8024 10.625 15.625 10.625H6.14417Z"
        fill={fill}
      />
    </Svg>
  );
};

export default ArrowBackLine;
